$(function () {
  // ページ内スクロールのみ（２）
  // スマホかPCによって、移動距離を調節してます。 :の前がPC後がスマホ。ヘッダーの高さ　PC：100、スマホ：なし
  var adjust = (navigator.userAgent.indexOf('iPhone') < 0 && navigator.userAgent.indexOf('iPod') < 0 && navigator.userAgent.indexOf('Android') < 0) ? 100 : 60;
  // 通常のクリック時
  $('a[href^="#"]').on("click", function () {
    var href = $(this).attr("href");
    scrollToAnker(href, adjust);
  });

  // 関数：スムーススクロール
  function scrollToAnker(href, adjust) {
    if (href !== "#") {
      var target = $(href === "" || href == "#top" ? 'html' : href);
      var speed = 800;
      var position = target.offset().top - adjust;
      $("html, body").stop().animate({ scrollTop: position }, speed, "swing");
    }
    return false;
  }

  // （２）ここまで


  // スマホメニュー設定
  $(".gnav-toggle").on("click", function(){
    $("header").toggleClass("open-nav");
  });

  $(".init-button").on("click", function(){
    $(this).parents("li").toggleClass("open-nav-under");
    var elmBtnPlus = $(this).find(".btn-plus");
    if (elmBtnPlus.text() === "＋") {
      elmBtnPlus.text("－");
    } else {
      elmBtnPlus.text("＋");
    }
  });

  // ヘッダー　index　トランスフォーム
  var _window = $(window),
    _header = $("header"),
    heroBottom;
  _window.on("scroll", function(){
    heroBottom = $(".main-visual").height();
    console.log(_window.scrollTop);
    
    if(_window.scrollTop() > heroBottom){
      _header.addClass("transform");
    } else {
      _header.removeClass("transform")
    }
  })

  var people_random = 0;
  // TOP Movie ランダム設定
  var handleWindowResize = function () {
      if (people_random) {
          var right = $(".index-people").find(".box-right:eq(0)");
          if (window.matchMedia("(max-width: 959px)").matches) {
              // 959以下のとき
            if (people_random == 3 || people_random == 4) {
                right.css("background-position", "10% center");
            } else if (people_random == 6) {
                right.css("background-position", "40% center");
            } else if (people_random == 9) {
                right.css("background-position", "20% center");
            }
          } else if (window.matchMedia("(min-width: 960px)").matches) {
              // 960以上のとき
            if (people_random == 3 || people_random == 4 || people_random == 6) {
                right.css("background-position", "560px");
            } else if (people_random == 9) {
              right.css("background-position", "400px");
            }
          }
      }
  }
  handleWindowResize();
  window.addEventListener("resize", function () {
    handleWindowResize();
  });

  if ($(".index-people").length) {
      var movies = [
          "_K-b3Kf4cYc",
          "q-FmW17HBrM",
          "Sh3C9aR8K6s",
          "Z__Cv9iQKQA",
          "cz7ejgHLwys",
          "8WjqbaUCCiE",
          "",
          "MmWoyZJm_c4",
          "k7k-Wt4vU8Q",
          "9TR31p-CF8Q"
      ];
      var movies2 = [
        "ppAvXKWMMyY",
        "FOH6kDpGhck"
      ];
      var targets = [".index-people"];
      $.each(targets, function(index, value) {
        var min = 1;
        var max = 10;
        var random = Math.floor( Math.random() * (max + 1 - min) ) + min;
        if (random == 7) random = 1;
        var right = $(value).find(".box-right:eq(0)");
        var file_num = ('00' + random).slice(-2);
        right.css("background-image", "url(img/img-movie-" + file_num + ".jpg)");
        if (random == 3 || random == 4 || random == 6 || random == 9) {
            people_random = random;
            handleWindowResize();
        }
        right.find("a:eq(0)").attr("href", "https://youtu.be/" + movies[random - 1]);
      });
  }
  var strings = ["foodtextile","wonder-shape","corporate-pr","resident","career","cate-style","index","contact","symposium"];
  var images_org = ['img/img-string-black.png','img/img-string-red.png','img/img-string-blue.png','img/img-string-orange.png','img/img-string-green.png'];
  var images = [];
  var rp = $(".rp:eq(0)").text();
  $.each(images_org, function(index, value) {
    images.push(rp + value);
  });
  $.each(strings, function(index, value){
      if ($("." + value).length) {
          $('.string').bgSwitcher({
              images: images,
              interval: 3000,
              loop: true,
              shuffle: true,
              effect: "fade",
              duration: 3000,
              easing: "linear"
          });
      }
  });

  // aos設定
  AOS.init();

  function fadeAnime(){
    $('.fadeInTrigger').each(function(){
      var elemPos = $(this).offset().top-50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight){
      $(this).addClass('fadeIn');
      }else{
      $(this).removeClass('fadeIn');
      }
      });
  }
  $(window).scroll(function (){
    fadeAnime();
  });
});

// fadethisの初期設定
// jQuery(window).fadeThis();
